import { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { slides } from "../../config/homePageUtils";
import Image from "../common/Image";
import Button from "../common/Button";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../LanguageProvider/LanguageProvider";
import video from "../../assets/images/landing/Invest_Uttarakhand.mp4";

const SliderSection = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const navigate = useNavigate();
  const [swiperInstance, setSwiperInstance] = useState(null);
  const { language } = useLanguage();

  useEffect(() => {
    if (swiperInstance && prevRef.current && nextRef.current) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);

  return (
    <section className="slider-section relative w-full overflow-hidden">
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src={video}
        autoPlay
        muted
        loop
        playsInline
      />
      <Swiper
        modules={[Navigation]}
        loop={true}
        className="w-full min-h-150"
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index} className="relative min-h-screen">
            <div className="relative z-20 pt-[260px] pb-28 sm:pt-75 sm:pb-52 text-block">
              <div className="container mx-auto">
                <div className="md:w-full text-white wow fadeInLeft">
                  <h1
                    className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold leading-snug sm:leading-snug md:leading-tight lg:leading-tight text-white"
                    dangerouslySetInnerHTML={{
                      __html: language ? slide.title.hi : slide.title.en,
                    }}
                  />
                  <div className="w-24 h-1 bg-white mt-2 mb-4"></div>
                  <p className="text-sm mb-8 max-w-md text-white rounded-[20px] bg-[#4f4f4f66] p-[20px] backdrop-blur-[10px] backdrop-saturate-[180%]">
                    {language ? slide.desc.hi : slide.desc.en}
                  </p>
                  <Button
                    onClick={() => {
                      navigate(slide.to);
                    }}
                    className="bg-white text-[#018f9b] font-medium px-6 py-3 rounded-full flex items-center w-fit hover:bg-[#befaff] hover:text-[#018f9b] transition] font-medium px-6 py-3 rounded-full flex items-center w-fit hover:bg-[#befaff] hover:text-[#018f9b] transition"
                  >
                    {language ? "योजना देखें" : "View Scheme"}{" "}
                    <span className="ml-2 text-lg">→</span>
                  </Button>
                  <div className="flex space-x-4 mt-8"></div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
        <div className="slider-navigation container">
          <button ref={prevRef} className="swiper-button-custom">
            {"<"}
          </button>
          <button ref={nextRef} className="swiper-button-custom">
            {">"}
          </button>
        </div>
        {/* Custom Navigation Buttons */}
      </Swiper>
    </section>
  );
};

export default SliderSection;
